import React from "react";
import "./Orders.scss";
import Home from "../Home/Home";
import { useNavigate } from "react-router-dom";
import { OrdersDashboard } from "./OrdersDashboard";
import { useState } from "react";
import { Sparks } from "../../assets/Icons/Sparks";

// Main container component for orders list page with AI assistant panel
export const OrdersHome = () => {
  const navigate = useNavigate();
  const [isRightSectionVisible, setIsRightSectionVisible] = useState(true);

  // Navigates back to home page
  const handleBackClick = () => {
    navigate("/home");
  };

  // Hides the right AI assistant section
  const handleClose = () => {
    setIsRightSectionVisible(false);
  };

  // Handles message sent to AI assistant
  const handleMessageSent = (text) => {
    navigate("/home", {
      state: { chatMode: "planMyDay", initialMessage: text },
    });
  };

  // Shows the right AI assistant section
  const handleReopenAI = () => {
    setIsRightSectionVisible(true);
  };

  return (
    <div
      className={`orders-home-container orders-page ${!isRightSectionVisible ? "full-width-mode" : ""}`}
    >
      <div className="orders-left-section">
        <OrdersDashboard isFullWidth={!isRightSectionVisible} />
      </div>
      {isRightSectionVisible && (
        <div className="orders-right-section">
          <Home
            showBackButton={true}
            onBackClick={handleBackClick}
            onClose={handleClose}
            orderHome={true}
            onMessageSent={handleMessageSent}
          />
        </div>
      )}
      {!isRightSectionVisible && (
        <div className="ai-reopen-button" onClick={handleReopenAI}>
          <Sparks width="24" height="24" color="#000" />
        </div>
      )}
    </div>
  );
};
